import moment from 'moment';
import { useContext, useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { AppContext } from 'src/app/modules/appContext/AppContext';
import { SIGNATURE_MODULE, SIGNATURE_OBJECT_TYPE, SIGNATURE_TYPE } from 'src/app/modules/component/button-in-phieu/constant';
import PrintButtonGroup from 'src/app/modules/component/print-button-group';
import { TimeEditor } from 'src/app/modules/component/time-editor/TimeEditor';
import { useTimeEditorManager } from 'src/app/modules/component/time-editor/useTimeEditorManager';
import { getErrorMessage } from 'src/app/modules/utils/FormatUtils';
import { hasAuthority, KEY_AUTHORITIES } from 'src/app/modules/utils/Permission';
import DanhSachPhieu from '../../../../component/DanhSachPhieu';
import LabelRequired from '../../../../component/LabelRequired';
import ShowStatus from '../../../../component/ShowStatus';
import { TableCollapseCustom } from '../../../../component/table/table-collapse/TableCollapseCustom';
import { columnsDSXetNghiem } from '../../../../phan-he-kham-benh/columns/tab-xet-nghiem/ColumnTabXetNghiem';
import CheckIcon from '../../../../phan-he-kham-benh/components/CheckIcon';
import { WORKFLOW_ORDER_GROUP_STATUS_CODE } from '../../../../phan-he-kham-benh/constants/ChiDinhDVConst';
import { classIdTabKhamBenh } from '../../../../phan-he-kham-benh/constants/KhamBenh';
import { useIndicationInfo } from '../../../../phan-he-kham-benh/hooks/useIndicationInfo';
import { ModalChonNgay } from '../../../../phan-he-kham-benh/modals/modal-ke-thuoc/components/NgayKeTuDong';
// import useViewportSize from 'src/app/hook/useViewportSize';
import { deleteDSChiDinhDV, getDSDVDaChiDinh, getTestIndicationInfo, updateOrderGroupFields } from '../../../../phan-he-kham-benh/services/ChiDinhDVService';
import { getStatusDesc } from '../../../../phan-he-kham-benh/services/KhamBenhService';
import { inPhieuChiDinhChung, inPhieuChiDinhCLS, inPhieuPhauThuatXNCLS } from '../../../../phan-he-kham-benh/services/PrintExportService';
import { CODE, KEY, KEY_DS_DANH_MUC_TIEP_DON, ORDER_TYPE_ID, RESPONSE_MESSAGE } from '../../../../utils/Constant';
import WfButton from '../../../../workflows/components/WfButton';
import { WfConstTracker, WfConstTrackerClinical } from '../../../../workflows/Constant';
import { usePhanHeNoiTruContext } from '../../../PhanHeNoiTruContext';
import { getDsPhieuDichVu } from '../../../services/HanhChinhServices';
import { cloneParaclinical } from '../../../services/Common';
import DynamicComponentNoiTru from '../components/DynamicComponentNoiTru';
import { ConfirmDialog } from 'src/app/modules/component/ConfirmDialog';
import { SelectEditor, useSelectEditorManager } from 'src/app/modules/component/select-editor';
import { seachUserMetadata } from 'src/app/modules/auth/core/_requests';
import useIndexDBValue from 'src/app/hook/useIndexDBValue';
import { IDanhSachDanhMuc } from 'src/app/modules/phan-he-tiep-nhan-thanh-toan/models/TiepDonModel';

type Props = {
  treatmentSheetId?: string
  allowOrder?: boolean
}

const XetNghiem = ({ treatmentSheetId, allowOrder = true }: Props) => {
  const { setIsLoading } = useContext(AppContext);
  const { benhNhanHanhChinh, statusChangedEvent, statusChangedEventFunc } = usePhanHeNoiTruContext();
  // const viewportSize = useViewportSize();

  const [dsPhieu, setDsPhieu] = useState<any[]>([]);
  const [selectedPhieu, setSelectedPhieu] = useState<any>(null);
  const [selectedIndex, setSelectedIndex] = useState<any>(0);
  const [dsXetNghiemDetail, setDsXetNghiemDetail] = useState<any[]>([]);
  const [dynamicData, setDynamicData] = useState<any>(null);
  const [statusDesc, setStatusDesc] = useState<any>([]);
  const [isUpdateWorkflow, setIsUpdateWorkflow] = useState(false);
  const [currentStatusWf, setCurrentStatusWf] = useState<string>();
  const [currentTreatmentId, setCurrentTreatmentId] = useState<string>(benhNhanHanhChinh?.treatmentId);
  const [selectedPhieuForClone, setSelectedPhieuForClone] = useState<any>(null);
  const [openModalTachPhieu, setOpenModalTachPhieu] = useState(false);
  const [validateMessage, setValidateMessage] = useState<string>('');
  const [shouldOpenConfirmDialog, setShouldOpenConfirmDialog] = useState<boolean>(false);

  const { value: danhSachDanhMuc } = useIndexDBValue<IDanhSachDanhMuc>({
    key: KEY_DS_DANH_MUC_TIEP_DON,
  });

  const allowEdit = !benhNhanHanhChinh?.concluded && hasAuthority(KEY_AUTHORITIES.UPDATE_FIELDS.PHIEU_CHI_DINH);

  //  Sử dụng custom hook để load indication info
  const { loadIndicationInfo } = useIndicationInfo({
    getIndicationInfo: getTestIndicationInfo
  });

  //  Sử dụng custom hook để quản lý indication time
  const indicationTimeManager = useTimeEditorManager({
    name: "indicationTime",
    values: selectedPhieu,
    updateFields: updateOrderGroupFields,
    onUpdateSuccess: (updatedData) => {
      if (!updatedData?.indicationTime) return;
      // Cập nhật selectedPhieu với data mới
      setSelectedPhieu((prev: any) => ({
        ...prev,
        indicationTime: updatedData.indicationTime
      }));

      // Cập nhật trong danh sách phiếu
      setDsPhieu((prevList: any[]) =>
        prevList.map((phieu: any) =>
          phieu.id === selectedPhieu?.id
            ? { ...phieu, indicationTime: updatedData.indicationTime, date: moment(updatedData.indicationTime).format("DD/MM/YYYY") }
            : phieu
        )
      );
    }
  });

  const indicationPersonSelectManager = useSelectEditorManager({
    name: "indicationPerson",
    idFieldName: "id",
    values: selectedPhieu,
    updateFields: updateOrderGroupFields,
    buildPayload: (option) => ({
      indicationPerson: option?.fullName,
      indicationTime: selectedPhieu?.indicationTime
    }),
    onUpdateSuccess: (updatedData) => {
      if (!updatedData?.indicationPerson) return;
      // Cập nhật selectedPhieu với data mới
      setSelectedPhieu((prev: any) => ({
        ...prev,
        indicationPerson: updatedData.indicationPerson
      }));

      // Cập nhật trong danh sách phiếu
      setDsPhieu((prevList: any[]) =>
        prevList.map((phieu: any) =>
          phieu.id === selectedPhieu?.id
            ? { ...phieu, indicationPerson: updatedData.indicationPerson }
            : phieu
        )
      );
    },
    enableConfirmWithReason: false, // Không dùng confirm with reason cho trường hình thức
  });

  const requestDeptNameSelectManager = useSelectEditorManager({
    name: "requestDeptName",
    idFieldName: "id",
    values: selectedPhieu,
    updateFields: updateOrderGroupFields,
    buildPayload: (option) => ({
      requestDeptCode: option?.code,
      requestDeptName: option?.name,
      indicationTime: selectedPhieu?.indicationTime
    }),
    onUpdateSuccess: (updatedData) => {
      if (!updatedData?.requestDeptName) return;
      // Cập nhật selectedPhieu với data mới
      setSelectedPhieu((prev: any) => ({
        ...prev,
        requestDeptName: updatedData.requestDeptName
      }));

      // Cập nhật trong danh sách phiếu
      setDsPhieu((prevList: any[]) =>
        prevList.map((phieu: any) =>
          phieu.id === selectedPhieu?.id
            ? { ...phieu, requestDeptName: updatedData.requestDeptName }
            : phieu
        )
      );
    },
    enableConfirmWithReason: false,
  });

  const actionChanged = (statusCode?: string) => {
    setCurrentStatusWf(statusCode);
    statusChangedEventFunc?.();
    handleSelectPhieu(selectedPhieu);
    setIsUpdateWorkflow(!isUpdateWorkflow);
    toast.success(RESPONSE_MESSAGE.SUCCESS);
  };

  const handleReset = () => {
    setDsPhieu([]);
    setSelectedPhieu(null);
    setDsXetNghiemDetail([]);
  };

  const handleClickWfButton = (data: any) => {
    setDynamicData({
      ...data,
      orderGroupId: selectedPhieu?.id,
      callbackFunc: () => {
        setSelectedIndex(0);
      },
      updateWorkflow: () => {
        setIsUpdateWorkflow(!isUpdateWorkflow);
      }
    });
  };

  const handleConfirmDelete = async () => {
    try {
      await deleteDSChiDinhDV(selectedPhieu?.id);
      statusChangedEventFunc?.();
      setSelectedIndex(0);
    } catch (error) {
      console.error(error);
      toast.error("Xảy ra lỗi, vui lòng thử lại!");
    }
  };

  const handleGetDsPhieu = async () => {
    try {
      let { data } = await getDsPhieuDichVu(benhNhanHanhChinh?.treatmentId, ORDER_TYPE_ID.XET_NGHIEM, treatmentSheetId);
      if (CODE.SUCCESS === data?.code) {
        let dsPhieuConverted = data?.data?.map((item: any, index: number) => {
          return {
            ...item,
            index,
            date: moment(item?.indicationTime).format("DD/MM/YYYY"),
          };
        });
        let currentIndex = benhNhanHanhChinh?.treatmentId !== currentTreatmentId ? 0 : selectedIndex;
        setDsPhieu(dsPhieuConverted || []);
        handleSelectPhieu(dsPhieuConverted?.[currentIndex] || dsPhieuConverted?.[0]);
      } else {
        handleReset();
      }
    } catch (error) {
      console.error(error);
      handleReset();
    }
  }

  const handleSelectPhieu = async (dataPhieu: any) => {
    try {
      if (!dataPhieu) {
        handleReset();
        return;
      };
      setSelectedIndex(dataPhieu?.index);

      // Gọi song song 2 API: lấy danh sách dịch vụ và thông tin chỉ định
      const [dvResponse, indicationInfo] = await Promise.all([
        getDSDVDaChiDinh({
          orderGroupId: dataPhieu?.id,
        }),
        loadIndicationInfo(dataPhieu?.id) //  Sử dụng hook
      ]);

      // Merge data với indication info từ TestGroup
      // QUAN TRỌNG: Giữ nguyên orderGroupId (dataPhieu.id), không để bị đè bởi TestGroup.id
      const updatedPhieu = {
        ...dataPhieu,
        ...(indicationInfo || {}), // Chỉ merge khi có data
        id: dataPhieu.id, // Luôn giữ orderGroupId
        testGroupId: indicationInfo?.id // Lưu TestGroupId riêng nếu cần
      };
      setSelectedPhieu(updatedPhieu);

      // Xử lý danh sách dịch vụ
      if (CODE.SUCCESS === dvResponse?.data?.code) {
        const newData = dvResponse.data.data?.map((item: any) => {
          return {
            ...item,
            terms: item?.terms?.map((term: any) => {
              if (term?.subs) {
                return {
                  ...term,
                  name: <CheckIcon data={term} color={term?.statusColor} className="ml-2" />,
                  subs: term?.subs?.map((sub: any) => {
                    return {
                      ...sub,
                      isCancel: term?.isCancel,
                      name: (
                        <CheckIcon
                          data={{ ...sub, isCancel: term?.isCancel }}
                          color={term?.statusColor}
                        />
                      ),
                    };
                  }),
                };
              } else {
                return {
                  ...term,
                  name: <CheckIcon data={term} color={term?.statusColor} />,
                };
              }
            }),
          };
        });
        setDsXetNghiemDetail(newData || []);
      } else {
        setDsPhieu([]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleGetStatusDesc = async () => {
    try {
      let { data } = await getStatusDesc(WfConstTracker.TEST_ORDER);
      if (data?.code === CODE.SUCCESS) {
        setStatusDesc(data?.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleClickClonePhieu = (phieu: any) => {
    setSelectedPhieuForClone(phieu);
    setOpenModalTachPhieu(true);
  };

  const handleSaveTachPhieu = async (selectedDates: any[]) => {
    if (!selectedDates || selectedDates.length === 0) {
      toast.warning('Vui lòng chọn ít nhất một ngày để sao phiếu');
      return;
    }

    if (!selectedPhieuForClone?.id) {
      toast.error('Không tìm thấy thông tin phiếu chỉ định');
      return;
    }

    if (!benhNhanHanhChinh?.treatmentId) {
      toast.error('Không tìm thấy thông tin đợt điều trị');
      return;
    }

    try {
      setIsLoading(true);
      const payload = {
        orderGroupId: selectedPhieuForClone.id,
        treatmentId: benhNhanHanhChinh.treatmentId,
        autoPrescriptions: selectedDates.map(date => ({
          prescriptionDate: date.value,
          treatmentSheetId: date.treatmentSheetId || ""
        }))
      };

      const { data } = await cloneParaclinical(payload);

      if (data?.code === CODE.SUCCESS) {
        toast.success('Sao phiếu thành công');
        setOpenModalTachPhieu(false);
        setSelectedPhieuForClone(null);
        statusChangedEventFunc?.();
        handleGetDsPhieu();
      } else {
        let errorMessage = getErrorMessage(data);
        setValidateMessage(errorMessage);
        setShouldOpenConfirmDialog(true);
      }
    } catch (error) {
      console.error('Error cloning service prescription:', error);
      toast.error('Có lỗi xảy ra khi sao phiếu. Vui lòng thử lại!');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    handleGetStatusDesc();
  }, []);

  useEffect(() => {
    setCurrentTreatmentId(benhNhanHanhChinh?.treatmentId);
  }, [benhNhanHanhChinh?.treatmentId]);

  useEffect(() => {
    benhNhanHanhChinh?.treatmentId && handleGetDsPhieu();
  }, [benhNhanHanhChinh?.treatmentId, statusChangedEvent, treatmentSheetId]);

  useEffect(() => {
    selectedPhieu && setCurrentStatusWf(selectedPhieu?.currStatusCode);
  }, [selectedPhieu]);

  return (
    <Row className="h-100 spaces px-4 py-5">
      <div>
        <div className="spaces pt-13 h-80 bg-white">
          <Row className="mx-0">
            <Col xs={4} className="d-flex align-items-center mb-3">
              <LabelRequired label="Mã phiếu" className="min-w-100px" />
              <span className="fw-light text-truncate">
                {selectedPhieu?.code || "..."}
              </span>
            </Col>
            {/*  Sử dụng shared component */}
            <Col xs={4} className="d-flex align-items-center text-lable-input mb-3">
              <LabelRequired label="Ngày y lệnh" className="min-w-100px" />
              <TimeEditor
                name="indicationTime"
                values={selectedPhieu}
                isEditingTime={indicationTimeManager.isEditingTime}
                editedTime={indicationTimeManager.editedTime}
                showValidationConfirm={indicationTimeManager.showValidationConfirm}
                validationMessage={indicationTimeManager.validationMessage}
                onEdit={indicationTimeManager.handleEditTime}
                onCancel={indicationTimeManager.handleCancelEdit}
                onSave={indicationTimeManager.handleSaveTime}
                onConfirmValidation={indicationTimeManager.handleConfirmValidation}
                onCancelValidation={indicationTimeManager.handleCancelValidation}
                onTimeChange={indicationTimeManager.setEditedTime}
                allowEdit={allowEdit}
              />
            </Col>
            <Col
              xs={4}
              className="d-flex align-items-center text-lable-input mb-3"
            >
              <LabelRequired label="Người chỉ định" className="min-w-100px" />
              <SelectEditor
                name="indicationPerson"
                values={{
                  indicationPerson: selectedPhieu?.indicationPerson
                }}
                options={[]}
                searchFunction={seachUserMetadata}
                searchObject={{ position: 1 }}
                urlData="data.content"
                getOptionLabel={(opt) => opt?.fullName || ""}
                inline={true}
                menuPlacement="top"
                isEditingSelect={indicationPersonSelectManager.isEditingSelect}
                editedValue={indicationPersonSelectManager.editedValue}
                showValidationConfirm={indicationPersonSelectManager.showValidationConfirm}
                showConfirmWithReason={indicationPersonSelectManager.showConfirmWithReason}
                validationMessage={indicationPersonSelectManager.validationMessage}
                onEdit={indicationPersonSelectManager.handleEditSelect}
                onCancel={indicationPersonSelectManager.handleCancelEdit}
                onSave={indicationPersonSelectManager.handleSaveSelect}
                onConfirmValidation={indicationPersonSelectManager.handleConfirmValidation}
                onCancelValidation={indicationPersonSelectManager.handleCancelValidation}
                onConfirmWithReason={indicationPersonSelectManager.handleConfirmWithReason}
                onCancelWithReason={indicationPersonSelectManager.handleCancelWithReason}
                onValueChange={indicationPersonSelectManager.setEditedValue}
                allowEdit={allowEdit}
              />
            </Col>
            <Col
              xs={4}
              className="d-flex align-items-center text-lable-input mb-3"
            >
              <LabelRequired label="Nơi chỉ định" className="min-w-100px" />
              <SelectEditor
                name="requestDeptName"
                values={{
                  requestDeptName: selectedPhieu?.requestDeptName
                }}
                options={danhSachDanhMuc?.listPhongKham || []}
                inline={true}
                menuPlacement="top"
                isEditingSelect={requestDeptNameSelectManager.isEditingSelect}
                editedValue={requestDeptNameSelectManager.editedValue}
                showValidationConfirm={requestDeptNameSelectManager.showValidationConfirm}
                showConfirmWithReason={requestDeptNameSelectManager.showConfirmWithReason}
                validationMessage={requestDeptNameSelectManager.validationMessage}
                onEdit={requestDeptNameSelectManager.handleEditSelect}
                onCancel={requestDeptNameSelectManager.handleCancelEdit}
                onSave={requestDeptNameSelectManager.handleSaveSelect}
                onConfirmValidation={requestDeptNameSelectManager.handleConfirmValidation}
                onCancelValidation={requestDeptNameSelectManager.handleCancelValidation}
                onConfirmWithReason={requestDeptNameSelectManager.handleConfirmWithReason}
                onCancelWithReason={requestDeptNameSelectManager.handleCancelWithReason}
                onValueChange={requestDeptNameSelectManager.setEditedValue}
                allowEdit={allowEdit}
              />
            </Col>
            <Col
              xs={8}
              className="d-flex align-items-center text-lable-input mb-3"
            >
              <LabelRequired label="Chẩn đoán" className="min-w-100px" />
              <span className="fw-light text-truncate">
                {selectedPhieu?.provisionalDiagnosisName || "..."}
              </span>
            </Col>
          </Row>
        </div>
        <div className="bg-white spaces pt-2 mb-6">
          <DanhSachPhieu
            className="mb-2"
            dsPhieu={dsPhieu || []}
            handleSelectRowData={handleSelectPhieu}
            selectedIndex={selectedIndex}
            additionalActions={[
              {
                iconClassName: "fa fa-clone",
                tooltip: "Sao phiếu",
                onClick: handleClickClonePhieu
              }
            ]}
          />
          <TableCollapseCustom
            columns={columnsDSXetNghiem}
            data={dsXetNghiemDetail}
            childrenField="subs"
            className={`overflow-auto spaces h-calc-vh-335`}
            handleClickRow={() => { }}
            isFromTabXN
          />
          <div className="d-flex justify-content-between align-items-center bg-white">
            <div className="d-flex">
              {benhNhanHanhChinh?.visitId &&
				benhNhanHanhChinh?.patientId &&
				selectedPhieu?.id &&
				WORKFLOW_ORDER_GROUP_STATUS_CODE.HUY_GUI_PHIEU !==
					currentStatusWf && (
					<PrintButtonGroup
						grouped={
							false
						}
						config={[
							{
								label: 'Phiếu chỉ định chung',
								fetchExport: inPhieuChiDinhChung,
								params: {
									visitId: benhNhanHanhChinh?.visitId,
									patientId: benhNhanHanhChinh?.patientId,
									orderGroupId: selectedPhieu?.id,
								},
							},
							{
								label: 'Phiếu chỉ định theo phòng',
								fetchExport: inPhieuChiDinhChung,
								params: {
									visitId: benhNhanHanhChinh?.visitId,
									patientId: benhNhanHanhChinh?.patientId,
									orderGroupId: selectedPhieu?.id,
									isSplit: true,
								},
							},
							{
								label: 'Phiếu chỉ định (F2)',
								keyBtn: KEY.F2,
								fetchExport: inPhieuChiDinhCLS,
								params: {
									visitId: benhNhanHanhChinh?.visitId,
									patientId: benhNhanHanhChinh?.patientId,
									orderGroupId: selectedPhieu?.id,
									orderTypeId: ORDER_TYPE_ID.XET_NGHIEM,
								},
							},
							{
								label: 'Phiếu kết quả (F3)',
								keyBtn: KEY.F3,
								signatureParams: {
									id: selectedPhieu?.id ?? '',
									objectType: SIGNATURE_OBJECT_TYPE.ORDER,
									module: SIGNATURE_MODULE.INPATIENT,
									type: SIGNATURE_TYPE.PHIEU_KQ_XN,
									medicalRecordId:
										benhNhanHanhChinh?.medicalRecordId,
									medicalRecordCode:
										benhNhanHanhChinh?.medicalRecordCode,
								},
								fetchExport: inPhieuPhauThuatXNCLS,
								params: {
									orderGroupId: selectedPhieu?.id,
									type: classIdTabKhamBenh.XET_NGHIEM.classId,
								},
							},
						]}
					/>
				)}
              {selectedPhieu?.isAllowModify && !benhNhanHanhChinh?.concluded && allowOrder && (
                <WfButton
                  tracker={WfConstTrackerClinical.ORDER_GROUP}
                  objectId={selectedPhieu?.id}
                  additionalFunc={actionChanged}
                  handleClick={handleClickWfButton}
                  forceRender={isUpdateWorkflow}
                />
              )}
            </div>

            <ShowStatus
              className="status-summary"
              statuses={statusDesc}
            />
          </div>

          {dynamicData && (
            <DynamicComponentNoiTru
              data={dynamicData}
              setData={setDynamicData}
              onConfirm={handleConfirmDelete}
            />
          )}

          {openModalTachPhieu && (
            <ModalChonNgay
              open={openModalTachPhieu}
              onClose={() => {
                setOpenModalTachPhieu(false);
                setSelectedPhieuForClone(null);
              }}
              onSave={handleSaveTachPhieu}
              treatmentId={benhNhanHanhChinh?.treatmentId}
            />
          )}

          {shouldOpenConfirmDialog && (
            <ConfirmDialog
              className="z-index-1060"
              show={shouldOpenConfirmDialog}
              title="Thông báo"
              message={validateMessage}
              close="Đóng"
              onCloseClick={() => {
                setValidateMessage('');
                setShouldOpenConfirmDialog(false);
              }}
            />
          )}
        </div>
      </div>
    </Row>
  );
}

export default XetNghiem